<template>
  <div class="subject-with-help" v-click-outside="close">
    <div class="subject-wrap">
      <div class="subject">
        <slot/>
      </div>
      <button
        class="small secondary"
        :class="{open}"
        @click="open=!open">
        <span>?</span>
      </button>
    </div>
    <transition-expand>
      <div v-if="open" class="help-block">
        <slot name="help"/>
      </div>
    </transition-expand>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { TransitionExpand } from 'vue-transition-expand'
export default {
  name: 'SubjectWithHelp',
  components: { TransitionExpand },
  directives: { ClickOutside },
  data: () => ({
    open: false
  }),
  methods: {
    close () {
      this.open = false
    }
  }
}
</script>

<style lang="scss">
  @import "../../../scss/vars";
  .subject-with-help {
    .subject-wrap {
      display: flex;
      align-items: center;

      .subject {
        margin-right: $small-padding;
      }
      button {
        position: relative;
        z-index: 0;

        &:after {
          content: '';
          position: absolute;
          width: 60%;
          height: 60%;
          border-radius: 50%;
          border: 1px dashed $px-color-grey-semi;
          z-index: -1;
          transition: width 0.05s, height 0.05s;
        }

        &.open {
          &:after {
            background: #fff;
            width: 90%;
            height: 90%;
          }
        }
      }
    }
    .help-block {
      margin-bottom: $basic-padding;
      font-size: $font-size-caption;
      color: transparentize($font-color, 0.2);
      max-width: $desc-max-width;

      b {
        color: #000;
        font-weight: unset;
      }

      p {
        font-size: $font-size-caption;
        line-height: unset;
        margin-bottom: $small-padding;
        top: unset;
      }
    }
  }
</style>
